export const gitCommit = 'c0c6a3d0'
